import DealTileTabSelect from './DealTileTabSelect';

export default DealTileTabSelect;
